import { useEffect, useState } from 'react';

import { DESKTOP_HEADER_ID } from '~/components/Header/constants';
import { useGlobal } from '~/hooks/useGlobal';

const MARGIN_BOTTOM = 20;

const getHeaderSize = () => {
  const header = document.getElementById(DESKTOP_HEADER_ID);

  if (!header) {
    return 0;
  }

  if (window.getComputedStyle(header).display === 'contents') {
    const children = Array.from(header.children) as HTMLElement[];
    const [firstChild, secondChild] = children;
    const scrollTop = window.scrollY;

    if (!firstChild || !secondChild) {
      return 0;
    }

    const firstHeight = firstChild.offsetHeight;
    const secondHeight = secondChild.offsetHeight;

    if (scrollTop > firstHeight + secondHeight) {
      const stickyContainer = header.querySelector(
        '[class*="stickyContainer"]',
      ) as HTMLElement;
      return stickyContainer ? stickyContainer.offsetHeight + MARGIN_BOTTOM : 0;
    }

    return children.reduce((total, child) => {
      const style = window.getComputedStyle(child);
      const marginBottom = parseInt(style.marginBottom) || 0;
      return total + child.offsetHeight + marginBottom;
    }, 0);
  }

  return (
    (header as HTMLElement).offsetHeight +
    parseInt(window.getComputedStyle(header).marginBottom)
  );
};

export const useHeaderSize = () => {
  const { isSSR } = useGlobal();
  const [headerSize, setHeaderSize] = useState(isSSR ? 0 : getHeaderSize());

  useEffect(() => {
    const handler = () => {
      setHeaderSize(getHeaderSize());
    };

    handler();
    window.addEventListener('resize', handler);
    window.addEventListener('scroll', handler);

    return () => {
      window.removeEventListener('resize', handler);
      window.removeEventListener('scroll', handler);
    };
  }, []);

  const getHeaderHeight = () => {
    return headerSize;
  };

  return {
    headerHeight: headerSize,
    getHeaderHeight,
  };
};
